import set from 'lodash/set';
import { produce } from 'immer';
import { useContext } from 'react';

import FormContext from 'src/presentation/contexts/FormContext';

export default function useDeleteTemporarySplit(attr) {
  const { onBlur, overrideState, workingState } = useContext(FormContext);

  return () => {
    const updatedState = produce(workingState, draftState => set(draftState, attr, []));
    overrideState && overrideState(updatedState);
    onBlur && onBlur({ currentState: updatedState });
  };
}
